import { TFunction, useTranslation } from "react-i18next"
import { InputModel } from "../../../../utils/types"
import { GridColDef } from "@mui/x-data-grid"
import StatusComponent from "../../../../components/status"
import { getStatus } from "../../../../hooks/status"
import { Color } from "../../../../utils/theme/types/color"
import { Status } from "../../../../utils/enums"
import { Box, Typography } from "@mui/material"

const useModelInput = () => {
    const { t } = useTranslation()
    return {
        from: {
            label: 'general.tags.from',
            translate: true,
            name: 'from',
            type: 'date',
            value: null,
            rest: {
                max: 'to',
            },
            size: {
                xl: 6,
                lg: 6,
                md: 6,
                sm: 6,
                xs: 6,
            },
            wrapChildren: ({ children, id }) => {
                return (
                    <Box key={id}>
                        <Typography sx={{
                            fontSize: '16px',
                            fontWeight: '600',
                            color: '#707070',
                            marginBottom: '20px',
                        }}>{t('general.filters')}</Typography>

                        {children}
                    </Box>
                )
            }
        },
        to: {
            label: 'general.tags.to',
            translate: true,
            name: 'to',
            type: 'date',
            value: null,
            rest: {
                min: 'from',
            },
            size: {
                xl: 6,
                lg: 6,
                md: 6,
                sm: 6,
                xs: 6,
            },
            itemChildren: {
                alignSelf: "end"
            }
        },
        area: {
            label: 'general.tags.area',
            translate: true,
            name: 'area',
            type: 'filter-select',
            items: [],
            value: null,
        },
        department: {
            label: 'general.tags.department',
            translate: true,
            name: 'department',
            type: 'filter-select',
            items: [],
            value: [],
        },
        questionnaire: {
            label: 'general.tags.questionnaire',
            translate: true,
            name: 'questionnaire',
            type: 'filter-select',
            items: [],
            value: [],
        },
        percentage: {
            label: 'Porcentaje de avance',
            name: 'percentage',
            type: 'percentage',
            value: null,
        },
        division: {
            label: 'general.tags.division',
            translate: true,
            name: 'division',
            type: 'filter-select',
            items: [],
            value: null,
            size: {
                xl: 12,
                lg: 12,
                md: 12,
                sm: 12,
            },
        },
        unidad_id: {
            label: 'general.tags.unit',
            translate: true,
            name: 'unidad_id',
            type: 'filter-select',
            items: [],
            value: null,
            size: {
                xl: 12,
                lg: 12,
                md: 12,
                sm: 12,
            },
        },
        user: {
            label: 'general.tags.user',
            translate: true,
            name: 'user',
            type: 'filter-select',
            items: [],
            value: null,
        },
    } as { [x: string]: InputModel }
}

const columsTranslate = ({ t, colors }: { t: TFunction<"translation", undefined>; colors: Color; }): GridColDef[] => {
    let column = {
        '1d': ([
            {
                field: 'unidad',
                headerName: 'ID - Unidad',
                width: 200,
                renderCell: (params: any) => {
                    return `${params.row.unidad}`;
                },
            },
            {
                field: 'division_unidad',
                headerName: 'División de la unidad',
                width: 200,
            },
            {
                field: 'zona',
                headerName: 'Zona',
                width: 150,
            },
            {
                field: 'usuario',
                headerName: 'Usuario asignado',
                width: 200,
            },
            {
                field: 'division_usuario',
                headerName: 'División de usuario',
                width: 200,
            },
            {
                field: 'tipo_usuario',
                headerName: 'Tipo de usuario',
                width: 150,
            },
            {
                field: 'area',
                headerName: t('general.tags.area'),
                width: 150,
            },
            {
                field: 'departamento',
                headerName: t('general.tags.department'),
                width: 200,
            },

            {
                field: 'cuestionario',
                headerName: 'Nombre del cuestionario',
                width: 200,
            },
            {
                field: 'fecha_inicio_programacion',
                headerName: 'Fecha de inicio',
                width: 200,
            },
            {
                field: 'fecha_fin_programacion',
                headerName: 'Fecha fin',
                width: 200,
            },
            {
                field: 'fecha_inicio_respuesta',
                headerName: 'Fecha de inicio de respuesta',
                width: 200,
            },
            {
                field: 'fecha_fin_respuesta',
                headerName: 'Fecha fin de respuesta',
                width: 200,
            },
            {
                field: 'tipo_programacion',
                headerName: 'Tipo de programación',
                width: 200,
            },
            {
                field: 'avance',
                headerName: 'Porcentaje de avance',
                width: 170,
            },

            {
                field: 'resultado',
                headerName: 'Resultado',
                width: 150,
            },

            {
                field: 'cuestionario_estatus',
                headerName: 'Estado del cuestionario',
                width: 200,
                renderCell: (row: any) => {
                    const statusQuestionnaire = getStatus(row.row.cuestionario_estatus_id as Status, colors, t)
                    return (
                        <StatusComponent
                            color={statusQuestionnaire?.color}
                            msg={statusQuestionnaire?.text}
                            size="small"
                        />
                    )
                },
            },



        ]),
    }
    return column["1d"];
}

const statusList = [Status.WAITING, Status.TO_BE_STARTED, Status.FINISHED, Status.INCOMPLETE, Status.EXPIRED, Status.CANCEL]
export { useModelInput, statusList, columsTranslate }